import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "locations-list" }


export default {
  __name: 'LocationsSkeleton',
  props: {
  skeletonCount: {
    type: Number,
    default: 4
  }
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.skeletonCount, (n) => {
      return (_openBlock(), _createElementBlock("div", {
        key: n,
        class: "location-item skeleton-location-item"
      }, [...(_cache[0] || (_cache[0] = [
        _createStaticVNode("<div class=\"location-main\"><div class=\"location-header d-flex justify-content-between align-items-center\"><div class=\"location-info flex-grow-1\"><div class=\"location-name-skeleton\"><div class=\"skeleton skeleton-icon\"></div><div class=\"skeleton skeleton-location-name\"></div></div><div class=\"skeleton skeleton-room-count-text mt-1\"></div><div class=\"skeleton skeleton-opening-hours mt-1\"></div></div><div class=\"location-actions\"><div class=\"skeleton skeleton-clock-button\"></div></div></div></div>", 1)
      ]))]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

}